/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClusterEventData
 */
export interface ClusterEventData {
    /**
     * 
     * @type {number}
     * @memberof ClusterEventData
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterEventData
     */
    duration?: number;
    /**
     * 
     * @type {string}
     * @memberof ClusterEventData
     */
    topic: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterEventData
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ClusterEventData
     */
    level?: number;
    /**
     * 
     * @type {object}
     * @memberof ClusterEventData
     */
    extraData?: object;
}

/**
 * Check if a given object implements the ClusterEventData interface.
 */
export function instanceOfClusterEventData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "topic" in value;

    return isInstance;
}

export function ClusterEventDataFromJSON(json: any): ClusterEventData {
    return ClusterEventDataFromJSONTyped(json, false);
}

export function ClusterEventDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterEventData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'topic': json['topic'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'extraData': !exists(json, 'extra_data') ? undefined : json['extra_data'],
    };
}

export function ClusterEventDataToJSON(value?: ClusterEventData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'duration': value.duration,
        'topic': value.topic,
        'message': value.message,
        'level': value.level,
        'extra_data': value.extraData,
    };
}

